module.exports = __webpack_public_path__ + "img/carousel-clientes-2.523e9128.png";